"use client";
import {
  tabs_default
} from "./chunk-TBXVIZ2K.mjs";
import "./chunk-6XM6DIWB.mjs";
import "./chunk-WIIQT7L4.mjs";
import {
  useTabs
} from "./chunk-73H64UCB.mjs";
import {
  tab_item_base_default
} from "./chunk-FXLYF44B.mjs";
export {
  tab_item_base_default as Tab,
  tabs_default as Tabs,
  useTabs
};
